export default {
  pickup: 'Ritiro',
  delivery: 'Consegna',
  ongoing_order: 'Ordine in corso',
  view_more: 'Tocca per vedere i dettagli',
  status: {
    rejected: {
      title: 'Ordine rifiutato',
      description: 'Tocca per vedere i dettagli',
    },
    created: {
      description: 'Ordine ricevuto',
    },
    reviewed: {
      description: 'Il tuo ordine è stato visto',
    },
  },
  order_type: {
    pickup: 'ritiro',
    delivery: 'consegna',
  },
  order_status_toast: {
    order_reviewed: '#{{number}} Il tuo ordine è stato visto',
    order_confirmed: '#{{number}} Confermato alle {{time}}',
    order_preparation_up_time_changed: '#{{number}} Orario di {{type}} cambiato a {{time}}',
    order_preparing: 'Il tuo ordine #{{number}} è in preparazione',
    order_rejected: '#{{number}} ordine rifiutato',
  },
  error_messages: {
    failed_to_load: 'Qualcosa è andato storto, riprova.',
  },
};
